<template>
  <div :class="'ali-modal'+(search?' with-search':'')">
    <div class="header">
      {{ title }}
      <br v-if="search"/>
      <input type="text" ref="focusMe" v-if="search" v-model="searchValue" class="form-control" placeholder="جستجو ...">
    </div>
    <div class="modal-content">
      <div :class="'select-item'+((selectedIds.indexOf(item._id)>=0)?' active':'')"
           @click="setSelected($event)" v-for="item in filteredItems" :key="item[itemId]" :data-value="item[itemId]">
        {{ item[itemTitle] }}
      </div>
    </div>
    <div class="footer">
      <button class="btn btn-info" @click="closeModal">بستن</button>
    </div>
  </div>
</template>

<script>
import {defineComponent} from 'vue';

export default defineComponent({
  name: 'Modal',
  mounted()
  {
    if (this.search)
    {
      const self = this;
      setTimeout(function (){
        self.$refs.focusMe.focus()
      },350)
    }
  },
  data: () =>
  {
    return {
      searchValue: ''
    }
  },
  computed:{
    filteredItems() {
      if (this.searchValue.length)
      {
        return this.items.filter(item => {
          return item[this.itemTitle].toLowerCase().indexOf(this.searchValue.toLowerCase()) > -1
        })
      }
      return this.items;
    }
  },
  props: [
    'items',
    'title',
    'itemTitle',
    'itemId',
    'name',
    'multiple',
    'setSelected',
    'search',
    'selectedIds',
    'closeModal'
  ],
  components: {}
});
</script>

<style scoped>
.ali-modal {
  height: 100%;
  border-radius: 5px;
}

.modal-content {
  border-radius: 5px;
  height: calc(100% - 95px);
  margin: 5px 0;
  overflow-y: auto;
  padding: 15px;
}

.with-search .modal-content {
  height: calc(100% - 135px);
}
.header {
  height: 40px;
  padding: 5px 15px;
  background: #f5f5f5;
}
.footer {
  height: 45px;
  padding: 5px 15px;
  background: #fff;
  text-align: left;
}
.footer .btn{
  margin-top: -5px;
}

.with-search .header {
  height: 80px;
}

.header {
  box-shadow: 0px 0 5px 5px rgba(0, 0, 0, 0.2);
  text-align: center;
  font-weight: bold;
}

.select-item {
  box-shadow: 0 0 5px 0px rgba(0, 0, 0, 0.2);
  border-radius: 4px;
  margin-bottom: 6px;
  padding: 5px 10px;
  color : black;
}

.select-item.active {
  background: #d9d9d9;
}
</style>